import React from 'react';
import './kick-start.css';

const m_main = () => {
    return (
        <div className="m_main__wrap m_main__wrap3">
            <div className="m_main container">
                <p className="m_main--data">Data Science Global Summit’22</p>
                <h1 className="m_main--title">Data Science Kick-start</h1>
                <p className="m_main--desc">Kick-start Your Data Science Career</p>
            </div>
        </div>
    );
};

export default m_main;